import { cx } from './cx'

export interface SkeletonProps {
  readonly width?: string | number
  readonly height?: string | number
  readonly variant?: 'text' | 'block' | 'circle'
  readonly className?: string
}

/**
 * Shimmer-sweep loading placeholder (components.md "Skeleton loader" —
 * `fx-shimmer`, 1.3s linear-gradient sweep), sized to match the content it
 * replaces by the caller passing width/height. `prefers-reduced-motion:
 * reduce` swaps the sweep for a static pulse via global.css's blanket motion
 * rule (interactions.md §6). Purely decorative — `aria-hidden` so screen
 * readers don't announce a stream of unlabeled placeholder blocks; the
 * loading state itself should be announced once by the containing region
 * (e.g. an `aria-busy` on the list, or a visually-hidden "Loading…" text).
 */
export function Skeleton({
  width = '100%',
  height = 16,
  variant = 'text',
  className,
}: SkeletonProps) {
  const classes = cx('skeleton', `skeleton-${variant}`, className)
  return <span className={classes} aria-hidden="true" style={{ width, height, display: 'block' }} />
}
